export default "__VITE_ASSET__1999542d__"